export const getPublicUrl = code =>
  `${location.protocol}//${location.host}/share/${code}`;
